import { Box, Typography, Card, CardContent, CardActionArea, Stack, Chip, Avatar } from '@mui/material';
import Iconify from '../../../../components/Iconify';

function CompanyCard({ company }) {
  return (
    <Card variant="outlined" sx={{ minWidth: 200, maxWidth: 240, flexShrink: 0, '&:hover': { boxShadow: 3 } }}>
      <CardContent sx={{ pb: '12px !important' }}>
        <Stack spacing={1}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.lighter', color: 'primary.main', fontSize: 14 }}>
              {company.name?.[0]?.toUpperCase()}
            </Avatar>
            <Typography variant="body2" fontWeight={600} noWrap>{company.name}</Typography>
          </Stack>
          {company.industry && (
            <Typography variant="caption" color="text.secondary">{company.industry}</Typography>
          )}
          <Stack direction="row" spacing={1} alignItems="center">
            <Iconify icon="mdi:account-group" sx={{ fontSize: 14, color: 'text.secondary' }} />
            <Typography variant="caption">{company.member_count} members</Typography>
          </Stack>
          <Chip
            label={company.status}
            color={company.status === 'active' ? 'success' : 'error'}
            size="small"
            sx={{ height: 18, fontSize: 10, width: 'fit-content' }}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}

export default function CompanyCards({ block }) {
  const { cards = [] } = block;
  return (
    <Box sx={{ my: 1.5 }}>
      {cards.length === 0 ? (
        <Typography variant="body2" color="text.secondary">No companies found.</Typography>
      ) : (
        <Box sx={{ display: 'flex', gap: 1.5, overflowX: 'auto', pb: 1 }}>
          {cards.map((c) => <CompanyCard key={c.id} company={c} />)}
        </Box>
      )}
    </Box>
  );
}
